import { useState, useEffect } from 'react';

const DESKTOP_MIN_WIDTH = 1025;

interface ScreenSize {
  width: number;
  isDesktop: boolean;
}

const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    width: typeof window === 'undefined' ? DESKTOP_MIN_WIDTH : window.innerWidth,
    isDesktop: typeof window === 'undefined' ? true : window.innerWidth >= DESKTOP_MIN_WIDTH,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        isDesktop: window.innerWidth >= DESKTOP_MIN_WIDTH,
      });
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export default useScreenSize;
